import { useCurrentUser } from 'lib/contexts/ApplicationState';
import { User } from 'lib/types/users';
import { Accounts } from 'features/Settings/AccountsTab';
import { AwaitUserAuth } from 'components/AwaitUserAuth';

const AccountsTabPage = () => (
  <AwaitUserAuth userRequired>
    <Accounts
      user={useCurrentUser() as User}
    />
  </AwaitUserAuth>
);

// eslint-disable-next-line import/no-default-export
export default AccountsTabPage;
